<!-- eslint-disable vue/valid-v-for -->
<template>
  <!-- <div class="box">
    <span>*点击按钮即视为同意众能联合企业版 《<span @click="openLink('a')" class="a_link">用户服务协议</span>》和 《<span @click="openLink('b')"
        class="a_link">隐私政策</span>》</span>
  </div> -->
  <div>
    <div style="display: flex; flex-direction: row; align-items: start;">
      <input 
        type="checkbox" 
        id="agree" 
        name="agree"
        v-model="checked"
        @change="()=>this.$props.onAgreeChange(checked)"
        style="margin-top: 5px;margin-right:10px" 
        required />
      <div v-html="appLoginAgreement"></div>
    </div>
    
    <div v-if="icpFiling" class="box icp">
      <span>ICP备案号：</span>
      <a :href="`https://beian.miit.gov.cn/#/Integrated/index`" target="_blank">
        {{ icpFiling }}
      </a>
    </div>
  </div>
</template>

<script>
import { isJSONString, setFavicon } from "@/utils/utils";

export default {
  name: "Privacy",
  props: ["onAgreeChange"],
  components: {},
  data() {
    return {
      appLoginAgreement: '',
      icpFiling: '',
      checked: false
    };
  },
  created() {},
  mounted() {
    try {
      if (isJSONString("uiInfo")) {
        const uiInfo = JSON.parse(localStorage.getItem("uiInfo"));
        this.appLoginAgreement = uiInfo.appLoginAgreement.replace(
          /\[《(.*?)》\]\((.*?)\)/g,
          ` 《<a style="color:#2255CC;" href="$2">$1</a>》 `,
        );
        this.icpFiling = uiInfo.icpFiling || '';
      }
    } catch (error) {}
  },
};
</script>
<style scoped>
a {
  color: #2255cc !important;
  cursor: pointer;
}

.box {
  padding: 12px 0;
  width: 100%;
  text-align: center;
  color: #a9a8a9;
}
.icp{
  padding: 0;
}
</style>
